import React, { useEffect, useRef, useState } from "react";
import Play from "../../assets/img/play.png";
import Pause from "../../assets/img/pause.png";

import Bee from "../../assets/img/bee.png";
import AnimatedView from "./AnimatedView";

const AudioPlayer = (props) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1.0); // Default speed

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.playbackRate = playbackRate; // Apply playback rate before playing
      audioRef.current.play().catch((e) => {
        //console.error("Error playing audio:", e);
      });
    }
  };

  const pauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  const togglePlayPause = () => {
    if (isPlaying) {
      pauseAudio();
    } else {
      playAudio();
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
  
    const handleEnded = () => {
      props.onAudioComplete?.(); // Call the focus callback
    };
  
    if (audio) {
      audio.addEventListener("ended", handleEnded);
    }
  
    return () => {
      if (audio) {
        audio.removeEventListener("ended", handleEnded);
      }
    };
  }, [props.onAudioComplete]);
  

  useEffect(() => {
    const _aAMode = localStorage.getItem("aAMode") === "true"; // Auto-play setting
    const _ttsPlaybackRate = localStorage.getItem("ttsPlaybackRate") || "1.0"; // Retrieve playback rate

    setPlaybackRate(parseFloat(_ttsPlaybackRate)); // Convert to float and set state

    if (props.init) {
      if (!_aAMode) {
        playAudio();
      }
    }
  }, [props.audioUrl, props.currentIndex, props.replay]);

  useEffect(() => {
    const audioElement = audioRef.current;

    if (audioElement) {
      audioElement.playbackRate = playbackRate; // Apply playback speed dynamically
    }
  }, [playbackRate]); // Update when playback rate changes

  useEffect(() => {
    const audioElement = audioRef.current;

    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
    };

    const handleEnded = () => {
      setIsPlaying(false);
    };

    if (audioElement) {
      audioElement.addEventListener("play", handlePlay);
      audioElement.addEventListener("pause", handlePause);
      audioElement.addEventListener("ended", handleEnded);
    }

    return () => {
      if (audioElement) {
        audioElement.removeEventListener("play", handlePlay);
        audioElement.removeEventListener("pause", handlePause);
        audioElement.removeEventListener("ended", handleEnded);
      }
    };
  }, []);

  const bigIconStyle = {
    cursor: "pointer",
    marginTop: `-${props.bee}`,
    marginLeft: props.bee ,
    height: "80px",
    width: "80px",
    opacity: 0.8,
    zIndex: 1000,
    alignContent: "end",
  };

  return (
    <>
      <audio ref={audioRef} src={props.audioUrl} preload="auto" />
      <div id="play-button">
        {props.bee == "90px" ? (<img id="question-image" src={Bee} />): null}
        
        {props.quiz ? (
          <AnimatedView animationType="zoom">
            {isPlaying ? (
              <div style={bigIconStyle} onClick={togglePlayPause}>
                <img style={{ width: "80px", height: "80px" }} src={Pause} />
              </div>
            ) : (
              <div style={bigIconStyle} onClick={togglePlayPause}>
                <img style={{ width: "80px", height: "80px" }} src={Play} />
              </div>
            )}
          </AnimatedView>
        ) : (
          <div>
            {isPlaying ? (
              <AnimatedView animationType="zoom">
                <div onClick={togglePlayPause} />
              </AnimatedView>
            ) : (
              <AnimatedView animationType="zoom">
                <div onClick={togglePlayPause}></div>
              </AnimatedView>
            )}
          </div>
        )}{" "}
      </div>
    </>
  );
};

export default AudioPlayer;
